export default class PaPayrollIndexController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/list', 'post', params, axiosOption, httpOption);
  }

  static groupList (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/groupList', 'get', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/paPayrollIndex/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/delete', 'post', params, axiosOption, httpOption);
  }

  static emptyBatch (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/emptyBatch', 'post', params, axiosOption, httpOption);
  }

  static resetBatch (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/resetBatch', 'post', params, axiosOption, httpOption);
  }

  static reset (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/paPayrollIndex/reset', 'post', params, axiosOption, httpOption);
  }
}
